import React, { useMemo } from 'react';
import { Select } from 'antd';
import useWindowDimensions from '../../../hooks/useWindowDimensions';
import { Avatars, MOBILE_DIMENSION } from '../../../constants/const';

const AstSelect = ({ players, setSelectedPlayer, selectedPlayer }) => {
  const options = useMemo(() => {
    return players.map((item) => {
      const playerName = item.childFirstName.concat(
        item?.childLastName ? `${' ' + item.childLastName}` : ' ',
      );
      return {
        label: (
          <span
            style={{
              display: 'flex',
              gap: '10px',
            }}
          >
            <img
              src={item.image || Avatars[parseInt(item.picture) - 1]}
              alt=""
              style={{
                width: '10px',
                objectFit: 'contain',
              }}
            />
            {playerName}
          </span>
        ),
        value: item.childId,
      };
    });
  }, [players]);

  const { width } = useWindowDimensions();
  const onChange = (value) => {
    setSelectedPlayer(value);
  };

  const onSearch = (value) => {};

  return (
    <Select
      showSearch
      placeholder="Player's Name"
      optionFilterProp="label"
      value={selectedPlayer}
      onChange={onChange}
      onSearch={onSearch}
      allowClear
      style={{
        width: width === MOBILE_DIMENSION ? 100 : 200,
        borderRadius: '50%',
      }}
      filterOption={(input, option) =>
        option?.label?.props?.children?.[1]?.toLowerCase().includes(input.toLowerCase())
      }
      options={options}
    />
  );
};

export default AstSelect;
